'use client'

import React from 'react'
import styles from './styles.module.css'
import SmartLink from '../../../SmartLink'
import SaleCountdown from '../../../SaleCampaign/SaleCountdown'
import { pathWithRegion } from '../../../../utils/regions'
import { getCampaignPhase, PHASE_LIVE, PHASE_TEASER, msOf } from '../../../../lib/saleCampaign'

// Slim strip at the top of /<region>/shop while the sale runs: what is on, the
// countdown to the end of the sale, and a link to the full sale page. The
// clock is owned by the Shop island (passed in) so the shop has one timer.
function SaleShopBanner({ campaign, nowMs, mounted, region }) {
  const phase = getCampaignPhase(campaign, nowMs)
  if (phase !== PHASE_LIVE && phase !== PHASE_TEASER) return null
  const live = phase === PHASE_LIVE
  const copy = campaign.shopBanner || {}
  const href = pathWithRegion(`/${campaign.route}`, region)

  return (
    <div className={styles.banner}>
      <div className={styles.text}>
        <span className={styles.kicker}>{live ? (copy.kickerLive || `${campaign.name} is live`) : (copy.kickerTeaser || `${campaign.name} starts soon`)}</span>
        <span className={styles.line}>
          {live
            ? (copy.lineLive || 'Sale prices are on every card with the sale tag.')
            : (copy.lineTeaser || 'All deals are published. See them now.')}
        </span>
      </div>
      <SaleCountdown
        targetMs={live ? msOf(campaign.end) : msOf(campaign.start)}
        nowMs={nowMs}
        mounted={mounted}
        size="sm"
        theme="dark"
        showDays={false}
        live
      />
      <SmartLink href={href} className={styles.cta}>{live ? (copy.ctaLive || 'All deals') : (copy.ctaTeaser || 'See the deals')}</SmartLink>
    </div>
  )
}

export default SaleShopBanner
